let phoneActive = false;
let currentPage = 2;
let fetchingProducts = false;
let bottomReached = false;

window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
        // Page was loaded from bfcache, force reload
        window.location.reload();
    }
});

//event for clicking outside selected product box
window.addEventListener('click', function (e) {
    var productAbs = document.getElementById('abs-s');
    var productBox = document.getElementById('s-box');
    if (productAbs) {
        if (!productBox.contains(e.target)) {
            productAbs.remove();
        }
    }
});

if (searchMode == false) {
    window.addEventListener("scroll", () => {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
            //get products when reaching bottom
            getProducts();
        }
    });
}

function onLoad() {
    //check if sections in navbar have x overflow
    if (navigator.userAgentData.mobile == true) {
        phoneActive = true;
        readaptToPhone();
    }
}

window.addEventListener('DOMContentLoaded', () => {
    checkSectionsOverflow();
    checkSectionsScrollPosition();
    scrollInsideElement('.selectedMain', '.sections-gallery', 30, 'x');
});


function getProducts() {
    if (fetchingProducts || bottomReached) {
        return;
    }
    fetchingProducts = true;
    loadingProductsCardAnimation();

    $.when($.ajax({
        type: "GET",
        url: scriptPath + `/API/Catalog/GetProducts?TableID=${TableID}&SectionID=${SectionID}&Page=${currentPage}`,
        headers: {
            RequestVerificationToken: $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result.trim() == "") {
                bottomReached = true;
            }
            else {
                $('#products-gallery').append(result);
                fetchingProducts = false;
                currentPage++;
            }
            removeProductsCardAnimation();
        },
        error: function (result) {
            showToast("No pudimos obtener los productos", "danger", 3000);
            console.log(result);
            removeProductsCardAnimation();
        }
    })).done(function () {

    });
}
function loadingProductsCardAnimation() {
    var animatedCard = `
        <div class="product-card prod-anim-card">
            <div class="image-container ">
                <img src="img/app/icon-gray.png">
            </div>
            <div class="info-container">
                <div class="description-container">
                </div>
                <div class="bottom-options-abs">
                    <div class="see-more">
                    </div>
                    <div class="cart-container">
                        <button style="" onclick=""></button>
                    </div>
                </div>
            </div>
        </div>
    `;

    $('#products-gallery').append(animatedCard);
    $('#products-gallery').append(animatedCard);
    $('#products-gallery').append(animatedCard);
    $('#products-gallery').append(animatedCard);
    $('#products-gallery').append(animatedCard);
    $('#products-gallery').append(animatedCard);
}
function removeProductsCardAnimation() {
    $('.prod-anim-card').remove();
}

function checkSectionsScrollPosition() {
    var selectedSectionElement = document.getElementsByClassName('selected')[0];
}
function validatePopup(FilePath) {
    const date = new Date;
    var dateNow = date.getMonth() + "/" + date.getDay();
    let popupSeen = window.localStorage.getItem(4);
    var popupPath = window.localStorage.getItem(5);
    var lastDateShown = window.localStorage.getItem(6);

    if (FilePath != "" && FilePath != null) {
        if (popupPath == null || popupPath == "") {
            window.localStorage.setItem(4, 1);
            window.localStorage.setItem(5, FilePath);
            window.localStorage.setItem(6, dateNow);
            openPopup(FilePath);
        }
        else {
            if (popupPath != FilePath || lastDateShown != dateNow) {
                //set the new path
                window.localStorage.setItem(5, FilePath);
                //create popup
                openPopup(FilePath);
                //flag as seen
                window.localStorage.setItem(4, 1);
                window.localStorage.setItem(5, FilePath);
                window.localStorage.setItem(6, dateNow);
            }
            else {
                window.localStorage.setItem(4, 0);
            }
        }
    }
}
function openPopup(FilePath) {
    var popupContainer = `<div class="popupContainer" id="popupContainer">
        <button type="button" onclick="this.parentElement.remove();"><i class="fa fa-times" aria-hidden="true"></i></button>
        <img id="popupImage" src="${FilePath}" onerror="this.src='img/app/no-product-image.png'" />
    </div>`;
    //create the popup
    $("body").append(popupContainer);
    var popupContainer = document.getElementById('popupContainer');
    setTimeout(function () {
        popupContainer.addEventListener('click', function (e) {
            var popupImage = document.getElementById('popupImage');
            if (!popupImage.contains(e.target)) {
                popupContainer.remove();
            }
        });
    }, 3000);
}
function readaptToPhone() {
    document.getElementById('section-search-filter').remove();
    document.getElementById('catalog-name-logo').remove();
    document.getElementsByClassName('product-div')[0].style.flexWrap = 'wrap';
    document.getElementsByClassName('right-side')[0].style.marginLeft = '0px';
    $('.my-account').remove();
    $('.orders').remove();
}
//login form selector
$(document).ready(function () {
    $(".loginSelector button").click(function (e) {
        var isActive = $(this).hasClass('activeOption');
        $('.activeOption').removeClass('activeOption');
        if (!isActive) {
            $(this).addClass('activeOption');
        }
    });
});

//event listener when resize
window.addEventListener("resize", checkSectionsOverflow);
function checkSectionsOverflow() {
    var el = document.getElementById('sections-gallery');
    var is = isOverflownX(el);
    var scrollBtns = document.getElementsByClassName('scrollXbutton');
    if (is) {
        for (var i = 0; i < scrollBtns.length; i++) {
            scrollBtns[i].style.display = "block";
        }
    }
    else {
        for (var i = 0; i < scrollBtns.length; i++) {
            scrollBtns[i].style.display = "none";
        }
    }
    function isOverflownX(element) {
        return element.scrollWidth > element.clientWidth;
    }
}

//execute search if ssearch focused and enter presseds
$('#searchInput').bind('keyup', function (e) {
    if (e.keyCode === 13) {
        onSearch();
    }
});
function onSearch() {
    var searchInput = document.getElementById('searchInput').value;
    //var sectionSearch = document.getElementById('section-search-filter').value;
    window.location.assign(`${apiPath}/Home?hfty=${TableID}&y=${SectionID}&f=${searchInput}&j=`);
}

function removefocusSectionSearch() {
    var sectionDropdown = document.getElementById('section-search-filter');
    sectionDropdown.style.border = "none";
}
function focusSectionSearch() {
    var sectionDropdown = document.getElementById('section-search-filter');
    sectionDropdown.style.border = "2px solid red";
}
function setPlaceHolder(el) {
    document.getElementById('searchInput').placeholder = `Buscar en ${el.options[el.selectedIndex].text}...`;
}

window.mobileCheck = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};


//custom datalist
window.addEventListener('click', function (e) {
    var suggestions = document.getElementById('suggestions');
    if (document.getElementById('searchInput').contains(e.target)) {
        // Clicked in box
    } else {
        suggestions.style.display = 'none';
    }
});
function customDatalist(input) {
    var suggestions = document.getElementById('suggestions');
    suggestions.style.display = 'block';
    input.style.borderRadius = "5px 5px 0 0";
}
function customDatalistOption(option) {
    var input = document.getElementById('searchInput');
    input.value = option.value;
    suggestions.style.display = 'none';
    input.style.borderRadius = "5px";
}
function onKeyPressCustomDatalist(input) {
    var currentFocus = -1;
    var e = document.getElementById('searchInput');
    var suggestions = document.getElementById('suggestions');
    var text = input.value.toUpperCase();

    if (text == "" || text == null) {
        let times = 1;
        for (let option of suggestions.options) {
            if (option.value.toUpperCase().indexOf(text) > -1 && times < 10) {
                option.style.display = "block";
                times++;
            } else {
                option.style.display = "none";
            }
        };
    }
    else {
        for (let option of suggestions.options) {
            if (option.value.toUpperCase().indexOf(text) > -1) {
                option.style.display = "block";
            } else {
                option.style.display = "none";
            }
        };
    }

    if (e.keyCode == 40) {
        currentFocus++
        addActive(suggestions.options);
    }
    else if (e.keyCode == 38) {
        currentFocus--
        addActive(suggestions.options);
    }
    else if (e.keyCode == 13) {
        e.preventDefault();
        if (currentFocus > -1) {
            if (suggestions.options)
                suggestions.options[currentFocus].click();
        }
    }
    function addActive(x) {
        if (!x) return false;
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0)
            currentFocus = (x.length - 1);
        x[currentFocus].classList.add("active");
    }
    function removeActive(x) {
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("active");
        }
    }
}

function filterOrder(element) {
    var filter, table, tr, td, i, txtValue;
    filter = input.value.toUpperCase();
    table = document.getElementById("table");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
        const tableData = tr[i].getElementsByTagName("td");
        let allTextContent = '';
        for (let ind = 0; ind < tableData.length; ind++) {
            allTextContent += tableData[ind].innerText;
        }

        if (allTextContent) {
            if (allTextContent.toUpperCase().indexOf(filter) > -1) {
                tr[i].style.display = "";
            } else {
                tr[i].style.display = "none";
            }
        }
    }
}

//cart functions
//ajaxs
function removeProductInfo() {
    document.getElementById('abs-s').remove();
}

function openImage(element) {
    $('body').append(`<div onclick="removeFocusImage(this)" class="imageFocusAbsolute"><img class="dim" src="${element.src}" /></div>`);
}
function removeFocusImage(element) {
    element.remove();
}
function getProduct(element, TableID, SectionID, ProductID) {
    $(element).append(`<div class="lds-ring" id="load-ring" style="margin-left: 5px;"><div></div><div></div><div></div><div></div></div>`);

    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home?handler=GetProduct&hfty=" + TableID + "&y=" + SectionID + "&f=" + ProductID,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: "",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result) {
                var a = '';
                if (result.availableStock == null) {
                    result.availableStock = 500;
                }
                if (result.packageOnly == true) {
                    for (let i = result.packageGeneral; i <= result.availableStock; i = i + result.packageGeneral) {
                        a = a + `<option value="${i}">${i} Unidad(es)</option>`;
                    }
                }
                else {
                    for (let i = 1; i < 501; i++) {
                        a = a + `<option value="${i}">${i} Unidad(es)</option>`;
                    }
                }

                var packageHtml = '';
                if (result.packageGeneral > 0) {
                    packageHtml = `<div class="s-package">
                                        <div class="s-ammount-title">
                                            <p>Bulto</p>
                                        </div>
                                        <div class="s-ammount-package">
                                            <p>${result.packageGeneral}</p>
                                        </div>
                                    </div>`
                }

                var noImageClass = "";
                if (result.pictureOne == "null" || result.pictureOne == null) {
                    noImageClass = "style='display:none;'";
                }

                var exclusiveOfferHtml = '';
                if (result.productPrice.exclusiveOffer == true) {
                    exclusiveOfferHtml = `
                        <div class="exc-offer-vp">
                            <p class="animateExclusive">${result.productPrice.exclusiveOfferDescription}</p>
                        </div>`;
                }

                var offerHtml = ``;
                if (result.productPrice.discountsSum > 0) {
                    offerHtml = `
                        <div class="discounts-section">
                            <span class="oldPrice">${result.individualPriceNoDiscountString}</span>
                            <p style="margin-left:5px; margin-right:5px; color: gray;"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></p>
                            <span class="newPrice">${result.individualPriceString}</span>
                            <div class="discountvp">
                                <p>-${result.productPrice.discountsSum}%</p>
                            </div>
                        </div>
                        <div class="total-section">
                            <span class="newPriceTotal">${result.priceString}</span>
                        </div>
                    `;
                }
                else {
                    offerHtml = `
                        <div class="total-section">
                            <span class="newPriceTotal">${result.priceString}</span>
                        </div>
                    `;
                }

                var favProdButton = ``;
                if (result.favouriteProduct == true) {
                    favProdButton = `<button type="button" class="favButtonProd" onclick="toggleToFav(this,'${TableID}','${SectionID}','${ProductID}'); removeProductInfo()">
                                        <i class="fa fa-heart" aria-hidden="true" style="margin-right: 5px;"></i>REMOVER DE FAVORITOS
                                    </button>`;
                }
                else {
                    favProdButton = `<button type="button" class="favButtonProd" onclick="toggleToFav(this,'${TableID}','${SectionID}','${ProductID}'); removeProductInfo()">
                                        <i class="fa fa-heart-o" aria-hidden="true" style="margin-right: 5px;"></i>AGREGAR A FAVORITOS
                                    </button>`;
                }


                $('body').append(`<div class="abs-s" id="abs-s">
                                    <div class="s-box dim" id="s-box">
                                        <div class="s-left">
                                            <div class="s-image-gallery">
                                                ${exclusiveOfferHtml}
                                                <div class="s-image" ${noImageClass}>
                                                    <img src="${result.pictureOne}" onerror="this.src='img/app/no-product-image.png'" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="s-right">
                                            <div class="s-desc">
                                                <div class="s-title">
                                                    <p>${result.description}</p>
                                                    <button type="button" onclick="this.parentElement.parentElement.parentElement.parentElement.parentElement.remove()"><i class="fa fa-times" aria-hidden="true"></i></button>
                                                </div>
                                                <div class="s-price" id="s-price">
                                                    ${offerHtml}
                                                </div>
                                                ${packageHtml}
                                                <div class="s-ammount">
                                                    <div class="s-ammount-title">
                                                        <p>Cantidad</p>
                                                    </div>
                                                    <div class="s-ammount-select">
                                                        <select id="ammountSelector" onchange="updatePrice(this,'${TableID}','${SectionID}','${ProductID}')">
                                                            ${a}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="s-submit">
                                                    <button type="button" onclick="addToCart(this,'${TableID}','${SectionID}','${ProductID}')"><i class="fa fa-shopping-cart" aria-hidden="true" style="margin-right: 5px;"></i>AGREGAR AL CARRITO</button>
                                                    ${favProdButton}
                                                </div>
                                                <div class="s-detail">
                                                    <h3>${result.longDescription != null && result.longDescription != '' ? "Descripción" : ""}</h3>
                                                    <p>${result.longDescription != null ? result.longDescription : ""}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>`);
                document.getElementById('load-ring').remove();
            }
        },
        error: function (result) {
            showToast("Ocurrió un error", "danger", 3000);
            document.getElementById('load-ring').remove();
            console.log(result);
        }
    })).done(function () {
    })
}
function updatePrice(element, TableID, SectionID, ProductID) {
    var data = {
        "ProductID": ProductID, "TableID": TableID, "SectionID": SectionID,
        Ammount: element.value, "AttributeOne": null
    }

    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home/Product?handler=CalculatePrice",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result.oldPrice != result.newPrice) {
                $('#s-price').empty();
                if (result.discount > 0) {
                    $('#s-price').append(`
                        <div class="discounts-section">
                            <span class="oldPrice">${result.oldPriceNoDiscount}</span>
                            <p style="margin-left:5px; margin-right:5px; color: gray;"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></p>
                            <span class="newPrice">${result.oldPrice}</span>
                            <div class="discountvp">
                                <p>-${result.discount}%</p>
                            </div>
                        </div>
                        <div class="total-section">
                            <span class="newPriceTotal">${result.newPrice}</span>
                        </div>
                    `);
                }
                else {
                    $('#s-price').append(`
                        <div class="total-section">
                            <span class="newPriceTotal">${result.newPrice}</span>
                        </div>
                    `);
                }
            }
            else {
                $('#s-price').empty();
                $('#s-price').append(`
                    <div class="total-section">
                        <span class="newPriceTotal">${result.newPrice}</span>
                    </div>
                `);
            }
        },
        error: function (result) {
            showToast("Ocurrió un error", "danger", 3000);
            console.log(result);
        }
    })).done(function () {

    })
}
function addToCart(element, TableID, SectionID, ProductID) {
    if (ClientID == null || ClientID == "") {
        //remove product box
        document.getElementById('abs-s').remove();
        //timeout bc the add event listener when clicking outside the sidenav hides the sidenav as it is opened
        setTimeout(function () {
            showSideNavMenu('login-section');
            openSideNav();
        },100)
        return;
    }

    $(element).append(`<div class="lds-ring" id="load-ring" style="margin-left: 5px;"><div></div><div></div><div></div><div></div></div>`);

    var Ammount = document.getElementById('ammountSelector').value;
    var data = {
        "ClientID": ClientID, "ProductID": ProductID, "TableID": TableID, "SectionID": SectionID,
        Ammount: Ammount, "AttributeOne": null, "AttributeTwo": null
    }

    //show loadbar
    document.getElementById('progress-bar').style.display = 'block';

    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home?handler=AddProductToCart",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            document.getElementById('progress-bar').style.display = 'none';
            document.getElementById('load-ring').remove();
            getTotals();

            //remove product box
            document.getElementById('abs-s').remove();

            var cartCount = document.getElementById('cart-ammount');
            var cartCount2 = document.getElementById('cart-ammount-2');
            var cartCount3 = document.getElementById('cart-ammount-3');
            cartCount.innerText = parseInt(cartCount.innerText) + 1;
            cartCount2.innerText = parseInt(cartCount2.innerText) + 1;
            cartCount3.innerText = parseInt(cartCount3.innerText) + 1;
            if (parseInt(cartCount.innerText) <= 0) {
                document.getElementsByClassName('checkout-btn-div')[0].style.display = 'none';
            }
            else {
                document.getElementsByClassName('checkout-btn-div')[0].style.display = 'flex';
            }

            //timeout bc the add event listener when clicking outside the sidenav hides the sidenav as it is opened
            setTimeout(function () {
                showSideNavMenu('sideNavCart');
                openSideNav();
            }, 100);

            ////append to sidenav cart
            var a = '';
            for (let i = 1; i < 501; i++) {
                a = a + `<option value="${i}">${i} Unidad(es)</option>`;
            }

            $(`#${result.index}-card`).remove(); //delete product if already exists in cart
            $('#cart-gallery').append(`<div class="cart-product" onmouseout="hideDeleteButton('${result.index}')" onmousemove="showDeleteButton('${result.index}')" id="${result.index}-card">
                    <div class="flex-left">
                        <img src="${result.pictureOne}" />
                    </div>
                    <div class="flex-fill">
                        <div title="${result.description}" class="cart-desc">
                            <p>${result.description}</p>
                        </div>
                        <div class="cart-attributes">
                        </div>
                        <div class="quantity-section">
                            <div class="selectCartAmmount">
                                    <select onchange="updateCartAmmount(this,'${TableID}','${ClientID}','${result.productID}','${result.sectionID}','null','${result.index}')">
                                    <option value="${result.ammount}">${result.ammount} Unidad(es)</option>
                                    ${a}
                                </select>
                            </div>
                        </div>
                        <div class="cart-price">
                            <p id="${result.index}-price">${result.priceString}</p>
                        </div>
                    </div>
                    <div class="flex-rgt" id="deleteButton-${result.index}">
                        <button onclick="deleteProductFromCart('${TableID}','${ClientID}','${result.productID}','${result.index}')"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                    </div>
                </div>`);

        },
        error: function (result) {
            showToast("Ocurrió un error", "warning", 3000);
            document.getElementById('progress-bar').style.display = 'none';
            document.getElementById('load-ring').remove();
        }
    })).done(function () {

    })
}
function checkSectionPassword(TableID, SectionID) {
    var input = document.getElementById('inputSectionPassword').value;

    if (input == "" || input == null) {
        showToast("Escribí una contraseña", "info", 3000);
        return;
    }

    var data = { "TableID": TableID, "SectionID": SectionID, "Input": input };

    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home?handler=CheckAuthenticateSection",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers: {
            RequestVerificationToken: $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            if (result == true) {
                sendNotifiactionToStorage(1, "Bienvenido!");
                $("#authSectionForm").submit();
            }
            else {
                showToast("Contraseña incorrecta", "danger", 3000);
            }
        },
        error: function (result) {
            console.log(result);
            showToast("Ocurrió un error", "warning", 3000);
        }
    })).done(function () {
    });
}
function setPage(value) {
    var params = new URLSearchParams(location.search);
    params.set('p', value);
    window.location.search = params.toString();
}


//destacados
document.addEventListener('DOMContentLoaded', function () {
    const ele = document.getElementById('fav-gallery');
    if (ele == null) {
        return;
    }
    ele.style.cursor = 'grab';

    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {
        ele.style.cursor = 'grabbing';
        ele.style.userSelect = 'none';

        pos = {
            left: ele.scrollLeft,
            top: ele.scrollTop,
            x: e.clientX,
            y: e.clientY,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        ele.scrollTop = pos.top - dy;
        ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
        ele.style.cursor = 'grab';
        ele.style.removeProperty('user-select');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    };

    ele.addEventListener('mousedown', mouseDownHandler);
});



var first = document.getElementsByClassName('first')[0];
var second = document.getElementsByClassName('second')[0];
var third = document.getElementsByClassName('third')[0];
var elementsArray = [];
var lastActiveNode;
var lastActiveNodeIndex;

if (first) {
    elementsArray.push(first);
}
if (second) {
    elementsArray.push(second);
}
if (third) {
    elementsArray.push(third);
}

if (elementsArray.length > 0) {
    elementsArray[0].classList.add('activeSlide');
}

function nextFav() {
    for (let i = 0; i < elementsArray.length; i++) {
        if (elementsArray[i].classList.contains('activeSlide')) {
            lastActiveNode = elementsArray[i];
            lastActiveNodeIndex = i;
            lastActiveNode.classList.remove('activeSlide');
            break;
        }
        else {
            
        }
    }

    if ((elementsArray.length - 1) != lastActiveNodeIndex) {
        elementsArray[lastActiveNodeIndex + 1].classList.add('activeSlide');
    }
    else {
        elementsArray[0].classList.add('activeSlide');
    }
}



